import { PreferenceItem } from '@sas/nova-core/services/preferences';
import { GlobalSettingsDataProvider } from '..';
import { getTopWindowAccessible } from '../../../util';

declare global {
  interface Window {
    transientStore: TransientPreferenceStore;
  }
}

// Matching the implementation of What we have in OpenUI5 to serve a hybrid deploy.
class TransientPreferenceStore {
  private state: { [key: string]: string } = {};

  public getItems() {
    return { ...this.state };
  }

  public putItems(items: Array<{ key: string; value: string | null }>) {
    for (const value of items) {
      if (typeof value.value === 'string') {
        this.state[value.key] = value.value;
      } else {
        delete this.state[value.key];
      }
    }
  }

  public removeItems(keys: Array<{ key: string }>) {
    for (const value of keys) {
      delete this.state[value.key];
    }
  }
}

export class TransientPreferenceService {
  private store: TransientPreferenceStore;

  constructor() {
    if (getTopWindowAccessible()) {
      if (!window.top!.transientStore) {
        Object.defineProperty(window.top, 'transientStore', {
          configurable: false,
          enumerable: true,
          value: Object.seal(new TransientPreferenceStore()),
        });
      }
      this.store = window.top!.transientStore;
    } else {
      this.store = new TransientPreferenceStore();
    }
  }

  public hasWriteAccess() {
    return Promise.resolve(true);
  }

  public setSettings(
    ...args: Parameters<GlobalSettingsDataProvider['setSettings']>
  ): ReturnType<GlobalSettingsDataProvider['setSettings']> {
    const data = args[0];
    const items: Array<{ key: string; value: string }> = data.map((item) => ({
      key: item.id,
      value: item.value,
    }));
    this.store.putItems(items);
    return Promise.resolve({ items: [...data] });
  }

  public getSettings(): ReturnType<GlobalSettingsDataProvider['getSettings']> {
    const storeItems = this.store.getItems();

    const items: Array<PreferenceItem> = [];

    for (const key in storeItems) {
      items.push({ id: key, value: storeItems[key] });
    }
    return Promise.resolve({ items });
  }

  public deleteSettings(
    ...args: Parameters<GlobalSettingsDataProvider['deleteSettings']>
  ): ReturnType<GlobalSettingsDataProvider['deleteSettings']> {
    const keys = args[0] as Array<string>;
    this.store.removeItems(keys.map((key) => ({ key })));
    return Promise.resolve();
  }
}
